import { primaryInput } from 'detect-it'

export function useIsDeviceTouchOnly() {
    return primaryInput === 'touch'
}
